/********** MusicforFilms **********
  /***** drawer *****/
    $(document).ready(function() {
      $('button.drawer_open').on('click', function(){
        $('nav#drawer').removeClass('drawer_hide').addClass('drawer_show');
        // $('main#MainContent > div:not(:eq(0))').animate({ opacity: 0 }, { duration: 400, easing: 'swing'});
      });
    });

    $(document).ready(function() {
      $('a.mobile-menu--close-btn, #drawer a').on('click', function(){
        $('nav#drawer').removeClass('drawer_show').addClass('drawer_hide');
        // $('main#MainContent > div:not(:eq(0))').animate({ opacity: 1 }, { duration: 600, easing: 'swing'});
      });
    });
  /***** /drawer *****/

  /***** delay load *****/
    $(function() {
      // $('main#MainContent').css({'display': 'none'});
      $('main#MainContent header').fadeIn(1000);
      $('main#MainContent > div.skmt_hero_top > div div.hero__text-shadow > h2 > div > img').fadeIn(1000);
      $('main#MainContent > div.skmt_cnt_top ul').fadeIn(1000);
      $('main#MainContent footer').fadeIn(1000);
      $('#skmtopusTopnews').fadeIn(1000);
      // $('main#MainContent').css({'visibility': 'visible'});
    });
  /***** /delay load *****/

  /***** scroll in *****/
    $(function(){
      $(window).on('load scroll', function() {
          $('#skmtopusTopnews, #skmtopusToprelease, #skmtopusTopmusiccommentary').each(function(){
              var elemPos = $(this).offset().top;
              var scroll = $(window).scrollTop();
              var windowHeight = $(window).height();
              if (scroll > elemPos - windowHeight + 150){
                  $(this).addClass('sldin');
          } else {
          $(this).removeClass('sldin');
              }
          });
      });
    });
  /***** /scroll in *****/

  /***** anchor *****/
    /* MUSICCOMMENTARY */
      $(function () {
        // var headH = $('header').outerHeight();
        // var navH = $('nav').outerHeight();
        // var sclH = headH + navH;
        var animeSpeed = 500;
        $(".skmtopus_musiccommentary_header a[href^='#']").on({
            "click": function () {
                var href = $(this).attr('href');
                var target = $(href == "#" || href === "" ? "html" : href);
                var position;
                // position = target.offset().top - 100;
                position = target.offset().top - 250;
                // $("body,html").stop().animate({
                $("body,html").animate({
                  scrollTop: position
                }, animeSpeed);
                return false;
            }
        });
      });
    /* /MUSICCOMMENTARY */

    /* TOP to MUSICCOMMENTARY */
      $(function(){
        const hash = location.hash;
        if(hash){
          $("html, body").stop().scrollTop(0);
          setTimeout(function(){
            /* position = target.offset().top - 250; */
            if (window.matchMedia('(max-width:768px)').matches) {
              const target = $(hash),
              position = target.offset().top - 120;
              $("html, body").animate({scrollTop:position}, 1000, "swing");
            } else if (window.matchMedia('(min-width:769px)').matches) {
              const target = $(hash),
              position = target.offset().top - 250;
              $("html, body").animate({scrollTop:position}, 1000, "swing");
            }
          });
        }
      });

      $(function(){
        $('section.skmtopus_musiccommentary_header > div.skmtopus_cnt > div > nav > ul > li > a').each(function(index, element){
          var $href = $(this).attr('href');
          if(location.hash.match($href)){
            $(this).addClass('active');
          }
        });
      });
    /* /TOP to MUSICCOMMENTARY */

    /* SP to MUSICCOMMENTARY */
      $(function () {
        // var headH = $('header').outerHeight();
        // var navH = $('nav').outerHeight();
        // var sclH = headH + navH;
        var animeSpeed = 500;
        $(".skmtopus_musiccommentary_spnav_drawer a[href^='#']").on({
            "click": function () {
                var href = $(this).attr('href');
                var target = $(href == "#" || href === "" ? "html" : href);
                var position;
                // position = target.offset().top - 100;
                position = target.offset().top - 120;
                // $("body,html").stop().animate({
                $("body,html").animate({
                  scrollTop: position
                }, animeSpeed);
                return false;
            }
        });
      });
    /* /SP to MUSICCOMMENTARY */

    /* TOP List */
      $(function () {
        $(window).on('load resize', function() {
          var headH = $('#skmtmff_ghead').outerHeight();
          // var navH = $('nav').outerHeight();
          // var sclH = headH + navH;
          var animeSpeed = 500;
          console.log('height:'+headH);
          $(".skmtmff_sclbtn a[href^='#']").on({
              "click": function () {
                  var href = $(this).attr('href');
                  var target = $(href == "#" || href === "" ? "html" : href);
                  var position;
                  // position = target.offset().top - 100;
                  position = target.offset().top - headH;
                  // $("body,html").stop().animate({
                  $("body,html").animate({
                    scrollTop: position
                  }, animeSpeed);
                  return false;
              }
          });
        });
      });
    /* /TOP List */
  /***** /anchor *****/

  /***** moretext *****/
    jQuery(function($){
      $('.showtxt_opus').click(function(){
        $(this).next('div').removeClass('hide txtfadeOut').addClass('show txtfadeIn');
        $(this).addClass('hide');
        return false;
      });
    });
    /* jQuery(function($){
      $('.hidetxt').click(function(){
        $.when(
          $('.more').addClass('hide txtfadeOut')
        ).done(function(){ 
          setTimeout(function() {
            $('.more').removeClass('show txtfadeIn');
          }, 500);
        });
        $('.showtxt').removeClass('hide');
        return false;
      });
    }); */
  /***** /moretext *****/

  /***** btn *****/
    $(document).ready(function() {
      $('a.btn_buy').mousedown(function () {
        $(this).addClass('down');
      });
      $('a.btn_buy').mouseup(function () {
        $(this).removeClass('down');
      });
    });
  /***** /btn *****/

  /***** newslistmoretext *****/
    jQuery(function($){
      $('section#news dt.showtxt').click(function(){
        $('section#news .more').removeClass('hide txtfadeOut').addClass('show txtfadeIn');
        $(this).addClass('hide');
        return false;
      });
    });
    jQuery(function($){
      $('section#topics dt.showtxt').click(function(){
        $('section#topics .more').removeClass('hide txtfadeOut').addClass('show txtfadeIn');
        $(this).addClass('hide');
        return false;
      });
    });
    /* jQuery(function($){
      $('.hidetxt').click(function(){
        $.when(
          $('.more').addClass('hide txtfadeOut')
        ).done(function(){ 
          setTimeout(function() {
            $('.more').removeClass('show txtfadeIn');
          }, 500);
        });
        $('.showtxt').removeClass('hide');
        return false;
      });
    }); */
  /***** /newslistmoretext *****/

  /***** height resize *****/
    $(function(){
      function adjust(){
        var h = $(window).height(); //ウィンドウの高さ
        // var h1= $('#header').height(); //他要素の高さ
        // $('#contents').css('height', h-h1); //可変部分の高さを適用
        $('body.template-page.skmtopus_movie article#skmtopusMovie').css('min-height', h - 470); //可変部分の高さを適用
        $('body.template-blog.skmtopus_news div.blog-layout__main').css('min-height', h - 690); //可変部分の高さを適用
        $('body.template-article.skmtopus_news div.blog-layout__main').css('min-height', h - 570); //可変部分の高さを適用
      }
      adjust();
      $(window).on('resize', function(){
        adjust();
      })
    });
  /***** /height resize *****/

  /***** a no link *****/
      $(function(){
          $('a.nolink').on('click', function() {
            return false;
          });
      });
  /***** /a no link *****/

  /***** modal *****/
    $(function(){
      var modal = $('.modalimg li');
      modal.on('click', function(){
        var src = $(this).children('img').prop('src');
        var tarr = src.split('/');
        var file = tarr[tarr.length-1];
        var imgPath = file.split('.')[0];
        $('#over').fadeIn(500);
        $('#modal').fadeIn(1000).html('<img src="https://cdn.shopify.com/s/files/1/0549/4879/0355/files/'+imgPath+'_2.jpg" alt=""><i id="close">×</i>');
        $('#modal').on('click', function(){
          return false;
        });
        $('#over, #close').on('click', function(){
          $('#over').fadeOut(500);
          $('#modal').fadeOut(100);
        });
      });
    });

    /* switcher 
      $(function(){
        $('.modal_switcher_select.modal_trigger').on('click', function(){
          $('.skmtopus_gnav, skmtopus_sectionheader').addClass('hide');
        });
        $('.modal_switcher_select.modal_trigger').on('click', function(){
          $('.skmtopus_gnav, skmtopus_sectionheader').removeClass('hide');
        });
      });
    /switcher */
  /***** /modal *****/

  /***** modal movie *****/
    $(function(){
        $(".js-modal-btn").modalVideo();
    });

    /* $(document).ready(function() {
      // YouTubeのコードを生成
      const getYouTubeVideoCode = url => {
        let inicio = url.indexOf('?') + 3,
        final = url.indexOf('&', inicio),
        code = final !== -1 ? url.slice(inicio, final) : url.slice(inicio),
        params = url.slice(final);
        return final !== -1 ? `${code}?${params}&` : `${code}?`;
      };

      // タグを出力してオブジェクトを作る
      const printYouTubeModal = videoCode => {
        let modal = document.createElement('div');
        modal.id = "modalYouTube";
        modal.classList.add('ed-modal');
        modal.innerHTML = `
        <div id="modalOverlay">
        <div class="modalContent">
          <div id="closeModal" class="ed-closeModal"></div>
            <div class="video">
              <iframe src="https://www.youtube.com/embed/${videoCode}autoplay=1" frameborder="0" allowfullscreen> </iframe>
            <div>
        </div>
        </div>`;
        document.body.appendChild(modal);
        closeModal(modal);
      };
      
      const element = document.getElementById('VideoModal'); 
      element.remove();

      // モーダルを閉じる場合
      const closeModal = modal => {
        document.getElementById('closeModal').addEventListener('click', () => {
          document.body.removeChild(modal);
        });
        document.getElementById('modalOverlay').addEventListener('click', () => {
          document.body.removeChild(modal);
        });  
        window.addEventListener('keyup', e => {
          if (e.key === 'Escape') {
            document.getElementById('closeModal').click();
          }
        });
      };

      // モーダルを開く
      const openYouTubeModal = selector => {
        let linksElements = [...document.querySelectorAll(selector)],
            links = linksElements.map(link => link.href);
        linksElements.forEach((el, i) => {
          el.addEventListener('click', e => {
            e.preventDefault();
            printYouTubeModal(getYouTubeVideoCode(links[i]));
          });
        });
      };

      openYouTubeModal('.skmtopus_movmodal');
    }); */
    
    /* function(evt) {
      if (this.modalIsOpen) {
        if (evt && !evt.target.closest(".js-modal-close")) {
          if (evt.target.closest(".modal__inner")) return
        }
        document.activeElement.blur(), this.modal.classList.remove(this.config.openClass), this.modal.classList.add(this.config.closingClass), document.documentElement.classList.remove(...this.config.bodyOpenClass), document.documentElement.classList.add(this.config.bodyClosingClass), window.setTimeout(function() {
          document.documentElement.classList.remove(this.config.bodyClosingClass), this.modal.classList.remove(this.config.closingClass), this.activeSource && this.activeSource.getAttribute("aria-expanded") && this.activeSource.setAttribute("aria-expanded", "false").focus()
        }.bind(this), 500), this.isSolid && document.documentElement.classList.remove(this.config.bodyOpenSolidClass), this.modalIsOpen = !1, theme.a11y.removeTrapFocus({
          container: this.modal,
          namespace: "modal_focus"
        }), document.dispatchEvent(new CustomEvent("modalClose." + this.id)), this.unbindEvents()
      }
    } */
  
  /***** /modal movie *****/

  /***** navi *****/
    $(function(){
      $('.skmtopus_gnav').each(function () {
        var $window = $(window),
        $nav = $(this),
        // navOffsetTop = $nav.offset().top - 500;
        navOffsetTop = $nav.offset().top;
        $window.on('scroll', function () {
          if ($window.scrollTop() > navOffsetTop) {
            $nav.addClass('fixed');
          } else if ($window.scrollTop() <= navOffsetTop) {
            $nav.removeClass('fixed');
          }
        });
        $window.trigger('scroll');
      });
    });

    $(function(){
      $('.skmtopus_sectionheader').each(function () {
        var $window = $(window),
        $nav = $(this),
        // navOffsetTop = $nav.offset().top - 500;
        navOffsetTop = $nav.offset().top - 50;
        $window.on('scroll', function () {
          if ($window.scrollTop() > navOffsetTop) {
            $nav.addClass('fixed');
          } else if ($window.scrollTop() <= navOffsetTop) {
            $nav.removeClass('fixed');
          }
        });
        $window.trigger('scroll');
      });
    });

    $(function(){
      $('#skmtopusTophero .skmtopus_top_img h1 img').each(function () {
        var $window = $(window),
        $nav = $(this),
        $navh = $('.skmtopus_gnav'),
        navOffsetTop = $nav.offset().top + $navh.height();
        $window.on('scroll', function () {
          if ($window.scrollTop() > navOffsetTop) {
            $('.skmtopus_top .skmtopus_gnav h1').addClass('txtfadeIn');
          } else if ($window.scrollTop() <= navOffsetTop) {
            $('.skmtopus_top .skmtopus_gnav h1').removeClass('txtfadeIn');
          }
        });
        $window.trigger('scroll');
      });
    });
  /***** /navi *****/

  /***** musiccommentary navi *****/
    jQuery(function($){
      $('section.skmtopus_musiccommentary_header nav a').click(function(){
        $('section.skmtopus_musiccommentary_header nav a').removeClass('active');
        $(this).addClass('active');
        return false;
      });
    });

    /* SP */
      jQuery(function($){
        $('div.skmtopus_musiccommentary_spnav button').click(function(){
          var btn = $('div.skmtopus_musiccommentary_spnav button').hasClass('active');
          if(btn) {
            $('nav.skmtopus_musiccommentary_spnav_drawer').addClass('hide');
            $('nav.skmtopus_musiccommentary_spnav_drawer').animate({ opacity: 0 }, { duration: 400, easing: 'swing'});
            $(this).removeClass('active');
          } else {
            $('nav.skmtopus_musiccommentary_spnav_drawer').removeClass('hide');
            $('nav.skmtopus_musiccommentary_spnav_drawer').animate({ opacity: 1 }, { duration: 400, easing: 'swing'});
            $(this).addClass('active');
          }
        });
      });

      jQuery(function($){
        $('nav.skmtopus_musiccommentary_spnav_drawer a').click(function(){
          $('nav.skmtopus_musiccommentary_spnav_drawer').addClass('hide');
          $('nav.skmtopus_musiccommentary_spnav_drawer').animate({ opacity: 0 }, { duration: 400, easing: 'swing'});
          $('div.skmtopus_musiccommentary_spnav button').removeClass('active');
          return false;
        });
      });
    /* /SP */
  /***** /musiccommentary navi *****/

  /***** interview tab *****/
    $(function () {
      var tabbtn = $('section.skmtopus_interview_header li > a');
      $(tabbtn).on('click', function() {
        var index = $(tabbtn).index(this);
        var tabid = $(this).attr("href");
        var tabdata = $(this).data('box');
        var tabiddata = (tabid+'.'+tabdata);
        var target = $('section.skmtopus_cnt_detail');
        $(tabbtn).removeClass('active');
        $(this).addClass('active');
        $(target).removeClass('show').fadeOut(300);
        $('.'+tabdata).children(tabid).removeClass('hide').addClass('show').fadeIn(700);
        $('html,body').animate({
          scrollTop: 0
        }, 300);
        return false;
      });
    });  
  /***** /interview tab *****/

  /***** slick *****/
    $(document).ready(function(){
      $('.itemSlider').slick({
        // arrows: false,
        // centerMode: true,
        // centerPadding: '18%',
        cssEase: 'ease',
        dots: true,
        dotsClass: 'dotPaging',
        fade: true,
        pauseOnDotsHover: true,
        // autoplay: false,
        autoplay: true,
        // 自動再生で切り替えをする時間
        autoplaySpeed: 5000,
        // 自動再生や左右の矢印でスライドするスピード
        speed: 2000,
        // 自動再生時にスライドのエリアにマウスオンで一時停止するかどうか
        pauseOnHover: false,
        slidesToShow: 1,
        slidesToScroll: 1,

        /* responsive: [
          {
            breakpoint: 812,
            settings: {
              centerMode: true,
              centerPadding: '15%'
            }
          }
        ] */

      });
    });

    $(document).ready(function() {
      var video = document.getElementById('v1');
      var vtime = 'false';
      if(video.paused) {
        var vtime = 'true';
        $('.itemSlider_rls').slick({
          cssEase: 'ease',
          dots: true,
          dotsClass: 'dotPaging',
          fade: true,
          autoplay: vtime,
          autoplaySpeed: 5000,
          speed: 2000,
          pauseOnFocus: false,
          pauseOnHover: false,
          pauseOnDotsHover: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        });
        video.addEventListener('pause', function(event) {
          $('.itemSlider_rls').slick('slickPause');
          $('.slick-initialized button').on('click', function() {
            $('.itemSlider_rls').slick('slickPlay');
          });
        });
        document.getElementById('v1').addEventListener("timeupdate", function() {
          video.addEventListener('pause', function(event) {
            $('.itemSlider_rls').slick('slickPause');
            $('.slick-initialized button').on('click', function() {
              $('.itemSlider_rls').slick('slickPlay');
            });
          });
          if(video.duration > video.currentTime) {
            $('.itemSlider_rls').addClass('slideauto');
            $('.slideauto').removeClass('itemSlider_rls');
            $('.slideauto').slick('slickPause');
            $('.slideauto2').slick('slickPlay');
            $('.slick-initialized button').on('click', function() {
              $(video).get(0).pause();
              $('.slideauto').addClass('slideauto2');
              $('.slideauto2').addClass('itemSlider_rls');
              $('.slideauto2').removeClass('slideauto');
            });
          } else {
            $('.slideauto').addClass('itemSlider_rls');
            $('.slideauto2').addClass('itemSlider_rls');
            $('.itemSlider_rls').removeClass('slideauto');
            $('.itemSlider_rls').slick('slickPlay');
          }
        });
        
      }
    });
  /***** /slick *****/

  /***** timer *****/
    $(document).ready(function() {
      $.ajax({
          type: 'GET',
          cache: false
        }).done(function(data, status, xhr) {
          var serverDate = new Date(xhr.getResponseHeader('Date'));
          var setStart = new Date('2024/06/06 14:25:59');

          $(".show_timer").each(function(index, target) {
            var startDate = $(this).attr("data-startdate");
            var endDate = $(this).attr("data-enddate");
            var svDate = new Date(serverDate);
            var stDate = new Date(startDate);
            var edDate = new Date(endDate);

            if(svDate >= stDate || !stDate && svDate < edDate || svDate < edDate){
              $(this).removeClass('hide');
            }

            if(stDate < edDate){
              if(svDate < stDate){
                $(this).addClass('hide');
              } else {
                $(this).removeClass('hide');
              }
            }

            if(svDate >= edDate){
              var tgt = !$(this).hasClass('hide');
              if(tgt && (svDate < stDate || stDate < edDate || !stDate) && svDate >= edDate){
                $(this).addClass('hide');
              }
            }

          });

        }).fail(function() {
          var date = new Date();

          $(".show_timer").each(function(index, target) {
            var startDate = $(this).attr("data-startdate");
            var endDate = $(this).attr("data-enddate");
            var ctDate = new Date(date);
            var stDate = new Date(startDate);
            var edDate = new Date(endDate);

            if(ctDate >= stDate || !stDate && ctDate < edDate || ctDate < edDate){
              $(this).removeClass('hide');
            }

            if(stDate < edDate){
              if(ctDate < stDate){
                $(this).addClass('hide');
              } else {
                $(this).removeClass('hide');
              }
            }

            if(ctDate >= edDate){
              var tgt = !$(this).hasClass('hide');
              if(tgt && (ctDate < stDate || stDate < edDate || !stDate) && ctDate >= edDate){
                $(this).addClass('hide');
              }
            }

        });

      });

    });
  /***** /timer *****/
/********** /MusicforFilms **********/